import { put, call, getContext } from "redux-saga/effects";

import { uploadFileClaim } from "../../Services/ClaimCashless";

export function* uploadFileClaimSaga(action) {
  const store = yield getContext("store");

  const { payload } = action;
  try {
    const res = yield call(
      uploadFileClaim,
      payload,
      // callback progress
      (percent) => {
        // console.log("saga", percent);
        store.dispatch({
          type: "REQ_UPLOAD_FILE_CLAIM_PROGRESS",
          progress: percent,
        });
      }
    );

    yield put({
      type: "REQ_UPLOAD_FILE_CLAIM_SUCCESS",
      data: {
        instanceId: payload.instanceId,
        claimId: payload.claimId,
        data: res.data,
      },
    });
  } catch (e) {
    yield put({
      type: "REQ_UPLOAD_FILE_CLAIM_FAILED",
      errData: { e, claimId: payload.claimId, instanceId: payload.instanceId },
    });
  }
}
